module.exports = __webpack_public_path__ + "static/img/popback.c9cda08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slots/popback.png
// module id = +7bI
// module chunks = 0